import { useSnapshot } from '../useSnapshot';
import { useStore } from '../FronteggStoreContext';
export function useTeamState() {
  const state = useStore().store.auth.teamState;
  return useSnapshot(state);
}
export const useTeamActions = () => {
  return useStore().stateActions.auth.teamActions;
};
const defaultMapper = state => state;
/**
 * @deprecated use useTeamState instead
 */

// @deprecated use useTeamState() instead
export function useAuthTeamState(stateMapper = defaultMapper) {
  return stateMapper(useTeamState());
}

/**
 * @deprecated use useTeamActions instead
 */
export const useAuthTeamActions = () => {
  return useTeamActions();
};